module.exports = __webpack_public_path__ + "97a380b3c8f6ec8f646a28309602d07b.svg";